import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "LanguageSelector" })
export default class LanguageSelector extends Vue {
    public localizer: any = Localizer;

    get routes() {
        return (<any>window).App.routes;
    }

    get isVisible(): any {
        return this.$store.getters["languageSelectorStore/isVisible"];
    }

    @Prop() readonly language: string;

    public closeDialogue() {
        this.$store.commit("languageSelectorStore/setVisible", false);

        document.body.classList.remove("overflow");
    }
};